<template>
  <div class="view box grow">
    <page-headers
        :header="(!trailIocDetails.privilege ? 'Threat Progression: ' : 'Privilege Trail: ') + queryTrailLabel"
        :breadcrumbs="breadcrumbs"
    >
      <div class="box flex" slot="actions">
        <div style="display:flex; margin-top:37px;">
          <span v-if="$allow('cyber_attacks', 'read')">
            <el-tooltip class="item" effect="dark" content="Status" placement="bottom" :enterable="false">
              <el-tag
                  size="small"
                  :class="{
                  'status-tag':true,
                  'status-active': trailIocDetails.state === 'ACTIVE',
                  'status-inactive': trailIocDetails.state === 'INACTIVE',
                  'status-mitigated': trailStateModified || trailIocDetails.state === 'MITIGATED',
                  'status-reopened': trailIocDetails.state === 'REOPENED'
                }"
              >{{ !trailStateModified ? trailIocDetails.state : 'MITIGATED' }}</el-tag
              >
            </el-tooltip>
          </span>
        </div>
        <div class="box flex gaps right center">
          <span v-if="jiraTicketDetails !== 'None'">
            <a :href="jiraTicketDetails.jira_ticket_link" target="_blank"
            ><img v-once style="width:40px; height:41.7px;" src="/static/images/logos/jira_image.svg" alt="jira-icon"
            /></a>
          </span>
          <span
              class="mitigate-trail"
              v-if="$allow('cyber_attacks', 'write') && !trailStateModified && trailIocDetails.state !== 'MITIGATED'"
              v-show="!(trailIocDetails.trailSummary && trailIocDetails.trailSummary.score === 0)"
          >
            <el-tooltip
                class="item"
                effect="dark"
                content="Assign Threat Progression"
                placement="bottom"
                :enterable="false"
            >
              <user-button
                  :classList="trailIocDetails.ownerId ? 'shamrock-200' : ''"
                  :user="trailIocDetails.ownerId"
                  @button-click="handoffTrail(trailIocDetails)"
              ></user-button>
            </el-tooltip>
            <span class="icon-user-edit"> <i class="material-icons">edit</i> </span>
          </span>
          <span
              v-if="$allow('cyber_attacks', 'read')"
              v-show="!(trailIocDetails.trailSummary && trailIocDetails.trailSummary.score === 0)"
          >
            <el-tooltip class="item" effect="dark" content="Activities" placement="bottom" :enterable="false">
              <el-button type="text" @click="showTrailWorkHistory(queryTrailId)">
                <i style="width:28px; height:24px;" class="box nav-icon c-icon-history"/>
              </el-button>
            </el-tooltip>
          </span>
          <span v-if="!trailIocDetails.privilege">
            <el-divider direction="vertical"></el-divider>
            <el-select v-model="mitigationProgressState" style="width:190px;">
              <el-option
                  v-for="option in mitigationProgressOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                  :disabled="option.disabled"
              ></el-option>
            </el-select>
          </span>
        </div>
      </div>
    </page-headers>
    <div class="main-content">
      <el-row :gutter="0">
        <el-col :xl="6" :lg="7" :span="10">
          <el-tabs v-model="activeTab">
            <el-tab-pane name="threat-summary">
              <span slot="label">
                Threat Summary
                <span class="status display-inline-block" v-if="trailIocDetailsStatus === 'saved'">
                  <severity-tag
                      :classList="'button2 capitalize-first-letter'"
                      :severityLevel="trailIocDetails.trailSummary.progressionSeverity">
                  </severity-tag>
                </span>
              </span>
              <div v-if="trailIocDetailsStatus === 'saved'" class="killchain-info flex column">
                <threat-summary :trailIDetails="trailIocDetails"/>
                <!-- <div class="box center">{{ selectedIoC.seenTimeAgoFormatted }}</div> -->
                <div class="statistics box" v-if="trailIocDetails && trailIocDetails.trailSummary">
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-hosts"></i></div>
                    <div class="box grow" v-if="trailIocDetails.cloudNative">Roles</div>
                    <div class="box grow" v-else>Hosts</div>
                    <div class="box count">{{ trailIocDetails.trailSummary.hosts }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-lat-movement"></i></div>
                    <div class="box grow">Lateral Movement</div>
                    <div class="box count">{{ trailIocDetails.trailSummary.lateralmoves }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-detections"></i></div>
                    <div class="box grow">Detections</div>
                    <div class="box count">{{ trailIocDetails.trailSummary.iocs }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-recommendations"></i></div>
                    <div class="box grow">Recommendations</div>
                    <div class="box count">{{ responseProgressTitle.split('/')[1] }}</div>
                  </div>
                  <influencer-list
                      title="Influenced By"
                      :count="trailIocDetails.influencedBy ? trailIocDetails.influencedBy.length : 0"
                      :influence="trailIocDetails.influencedBy"
                      :table-id="`table-${queryTrailId.replace(/[#:.]/g, '-')}`"
                  ></influencer-list>
                  <influencer-list
                      title="Influences"
                      :count="trailIocDetails.influences ? trailIocDetails.influences.length : 0"
                      :influence="trailIocDetails.influences"
                      :table-id="`table-${queryTrailId.replace(/[#:.]/g, '-')}`"
                      :enable-click-state="false"
                  ></influencer-list>
                </div>
                <el-button
                    :disabled="!$allow('blocking-response', 'write')"
                    @click="
                    showBlockingResponseFeed = true
                    activeTab = 'response'
                  "
                    type="primary"
                >View Response Recommendations
                </el-button
                >
              </div>
            </el-tab-pane>
            <el-tab-pane name="response" v-if="$allow('blocking-response', 'write')">
              <span slot="label">
                Response <span class="status">{{ responseProgressTitle }}</span>
              </span>
              <blocking-response-feed
                  ref="blockingResponseFeed"
                  v-show="showBlockingResponseFeed"
                  :mitigation-progress-state="mitigationProgressState"
                  :recommendations="trailIocDetails.recommendations"
                  @selection-change="toggleRecommendationSelection"
                  @close="showBlockingResponseFeed = false"
              />
              <div v-show="!showBlockingResponseFeed" class="killchain-info flex column">
                <div class="command-chart box center">
                  <donut-chart-js
                      ref="responseProgressDonutChart"
                      :chart-info="selectedIoC"
                      :chart-data="responseProgress"
                      :chart-options="generateCommandChartOptions()"
                      :chart-plugins="donutholeChartLabelPlugin"
                  />
                </div>
                <div class="box center">
                  Progression reported on <strong>{{ $moment(selectedIoC.seenTime).format('MMM DD YYYY') }}</strong>
                </div>
                <div class="statistics box">
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-awaiting"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['default'])">
                      awaiting action
                    </div>
                    <div class="box count">{{ responseProgress.datasets[0].data[0] }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-dismissed"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['dismissed'])">
                      dismissed
                    </div>
                    <div class="box count">{{ responseProgress.datasets[0].data[1] }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-done"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['done'])">
                      marked done
                    </div>
                    <div class="box count">{{ responseProgress.datasets[0].data[2] }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-pending"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['pending'])">
                      in progress
                    </div>
                    <div class="box count">{{ responseProgress.datasets[0].data[3] }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-executed"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['executed'])">
                      executed
                    </div>
                    <div class="box count">{{ responseProgress.datasets[0].data[4] }}</div>
                  </div>
                  <div class="box flex gaps title">
                    <div class="box flex center"><i class="icon icon-score status-failed"></i></div>
                    <div class="box grow cursor-pointer" @click="setBlockingResponseFeedFilter(['failed'])">failed</div>
                    <div class="box count">{{ responseProgress.datasets[0].data[5] }}</div>
                  </div>
                </div>
                <el-button @click="showBlockingResponseFeed = true" type="primary"
                >View Response Recommendations
                </el-button
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :xl="18" :lg="17" :span="14" v-loading="trailIocDetailsStatus !== 'saved'">
          <div class="trail-details" v-if="trailIocDetailsStatus === 'saved'">
            <ioc-trail-table-element
                ref="trailTable"
                :table-id="queryTrailId"
                :table-height="'100%'"
                :trail="trailIocDetails"
                :on-row-click="handleSelectionChange"
                :host-count="trailIocDetails.trailSummary.hosts"
                :show-host-label="trailIocDetails.trailSummary.hosts<=10"
                :ioc-color-flag="iocColorFlag"
                :on-host-click="handleHostChange"
            ></ioc-trail-table-element>
          </div>
        </el-col>
      </el-row>
      <div class="aside-details display-inline-block" style="display: none">
        <aside-sidebar
            id="host-feed"
            parent=".layout-container"
            sibling=".trail-details"
            v-model="hideHostDataFeed"
            :feed-loading="false"
            :class="{ 'display-none': !toggleHostData }"
        >
          <div slot="title" class="agent-title-wrapper" v-if="!$_.isEmpty(agentSelected)">
            <div class="agent-title">
              <span class="agent-icon" :class="`icon-${agentSelected.agentDetails.system.os.toLowerCase()}`"></span>
              <div class="host-name">{{ agentSelected.agentDetails.hostname || agentSelected.agentIdLabel }}</div>
            </div>
            <router-link class="value"
                         :to="{ name: 'host-insights', params: { agentId: agentSelected.agentDetails.agentId } }">
              {{ "Full host details ->" }}
            </router-link>
          </div>
          <host-details-card slot="content" v-if="!$_.isEmpty(agentSelected)"
                             :agent="agentSelected"
                             :on-edit-criticality-click="handleOpenCriticalityDialog"></host-details-card>
          <div class="box self-center" v-else slot="no-content">No data</div>
        </aside-sidebar>
        <aside-sidebar
            id="history-feed"
            parent=".layout-container"
            sibling=".trail-details"
            :feed-loading="workHistoryLoading"
            v-model="hideActivitiesFeed"
            :class="{ 'display-none': toggleWorkHistory }"
        >
          <div slot="title"><h2 class="mv-0">Activities</h2></div>
          <activities-timeline-feed
              slot="content"
              :timeline-data="workHistoryDetails"
              v-if="workHistoryDetails.length"
          ></activities-timeline-feed>
          <div class="box self-center" v-else slot="no-content">No data</div>
        </aside-sidebar>

        <aside-sidebar
            id="ioc-details-feed"
            parent=".layout-container"
            sibling=".trail-details"
            :feed-loading="false"
            v-model="hideIoCDetails"
            ref="iocDetailsAside"
            :class="{
            'display-none': toggleIoCDetails,
            'process-lineage-details': toggleProcessLineageDetails
          }"
        >
          <div slot="title" class="aside-ioc-title">
            <div class="flex gaps align-baseline">
              <div class="box"><i class="fal fa-exclamation-circle"></i></div>
              <div class="box grow flex column">
                <div class="box flex gaps align-baseline">
                  <span class="box grow" v-if="!$_.isEmpty(iocDetails.rule) && !iocDetails.lateralmove">
                    <h2>{{ iocDetails.rule.name || iocDetails.iocDetail }}</h2>
                  </span>
                  <span class="box grow" v-if="iocDetails.lateralmove"> <h2>Lateral Movement</h2> </span>
                </div>
                <div class="box mt-16 mb-16" v-if="iocDetails.rule && iocDetails.rule.ruleDescription">
                  <v-clamp id="ruledetails-description" class="body1" :max-lines="5"
                           :expanded.sync="expandDescription.expanded">
                    {{ iocDetails.rule.ruleDescription }}
                  </v-clamp>
                  <span class="text-btn" @click="expandDescription.expanded = !expandDescription.expanded"
                        v-if="expandDescription.overflow">
                        {{ expandDescription.expanded ? 'Less Description' : 'Full Description' }}
                  </span>
                </div>
                <div class="box">
                  <time class="caption1">{{ $moment(iocDetails.seenTime).format('MM/DD/YY hh:mm:ss A') }}</time>
                </div>
                <div class="box" v-if="iocDetails.trailId">
                  <span class="caption1 cursor-pointer local-trailid">
                    Local Trail ID: {{ iocDetails.trailId }}
                    <span class="material-icons" v-show="insightsEnabled" @click="gotoTrailGraph">3d_rotation</span>
                    <span class="material-icons" v-show="insightsEnabled" @click="gotoThreatHunting">search</span>
                  </span>
                </div>
              </div>
              <!-- Process Lineage -->
              <div class="box score" v-if="!iocDetails.lateralmove">
                <span class="score body1">+{{ iocDetails.scoreContribution }}</span>
                <div
                    class="open-process-lineage cursor-pointer"
                    @click="toggleProcessLineageDetails = !toggleProcessLineageDetails"
                >
                  <span class="material-icons" v-if="!toggleProcessLineageDetails">keyboard_arrow_left</span>
                  <span class="material-icons" v-if="toggleProcessLineageDetails">keyboard_arrow_right</span>
                  <span class="material-icons">device_hub</span>
                </div>
              </div>
            </div>
            <!-- Allowlist -->
            <div class="box-for-Create-Allowlist">
              <el-button type="primary" v-if="!iocDetails.lateralmove" @click="openAllowlistDialogue">
                Create Allowlist
              </el-button>
            </div>
          </div>
          <lateral-movement-event-details
              v-if="iocDetails.lateralmove"
              slot="content"
              :ioc-details="iocDetails"
          ></lateral-movement-event-details>
          <ioc-multi-event-details
              v-else-if="iocDetails.multiEventList && !toggleProcessLineageDetails"
              slot="content"
              :ioc-details="iocDetails"
          ></ioc-multi-event-details>
          <ioc-event-details
              v-else-if="!iocDetails.multiEventList && !toggleProcessLineageDetails"
              slot="content"
              :ioc-details="iocDetails"
              :key="iocDetails.iocTactic"
          ></ioc-event-details>
          <process-lineage-graph
              v-else
              slot="content"
              :ioc="iocDetails"
              :key="iocDetails.iocHash"
          ></process-lineage-graph>
        </aside-sidebar>
      </div>
    </div>
    <edit-criticality-dialog :open-criticality-dialog-visible="openCriticalityDialog" :on-submit="onCriticalityChange"
                             :agent="agentSelected" :on-close="() => openCriticalityDialog = false"/>
    <el-dialog :title="dialogueBoxTitle" :visible.sync="openAssignToDialogVisible">
      <el-form :model="trailIocDetails" v-if="usersListStatus === 'saved'">
        <div class="container">
          <div class="left-section" style="color:#454B60">
            <el-form-item label="Assignee" prop="email">
              <div style="margin-left: 96px;">
                <el-select
                    class="threat-assignee_dropdown"
                    @change="handleThreatHandoffAssigneeChange"
                    v-model="trailIocDetails.assignTo"
                    filterable
                    :placeholder="trailIocDetails.ownerId ? trailIocDetails.ownerId.fullname : 'Unassigned'"
                >
                  <user-button
                      slot="prefix"
                      :classList="selectedAttackTrail.assignTo ? 'shamrock-200' : ''"
                      :user="selectedAssignee"
                  ></user-button>
                  <el-option
                      v-for="item in usersList.models"
                      :key="item.email"
                      :label="`${item.firstname} ${item.lastname}`"
                      :value="item.email"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="Status">
              <div style="margin-left:96px;">
                <el-select v-model="selectedTrailDetailsForJira.status" placeholder="Mitigation Not Started"
                           :disabled="!checked">
                  <el-option
                      v-for="item in jiraTicketStatusValues"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <div style="display:inline">
              <span style="font-weight: 500;"> Comment </span>
              <el-input
                  style="display:inline"
                  type="textarea"
                  rows="5"
                  v-model="selectedTrailDetailsForJira.comments"
              ></el-input>
            </div>
          </div>
          <div class="right-section">
            <div style="margin-left:39px;">
              <div style="display:flex;">
                <div>
                  <span>
                    <img
                        v-once
                        style="width:42px; height:44.7px; margin-left:15px;"
                        src="/static/images/logos/jira_image.svg"
                        alt="jira-icon"
                    />
                  </span>
                </div>
                <div style="margin-top:13px;">
                  <span class="jira-text-integrate-with-jira">
                    Create Jira ticket*
                  </span>
                  <el-checkbox style="margin-left:10px;" v-model="checked"
                               :disabled="disableCheckboxOnPopUp"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="the-title-of-threat-copy">
              <span>
                Threat Progression and description<br/>
                will appear as Jira issue.
              </span>
            </div>

            <div v-if="checked">
              <div class="jira-project-alignment">
                <el-form-item class="jira-project-selection" label="Project">
                  <div style="margin-left:70px;">
                    <el-select
                        v-model="selectedTrailDetailsForJira.projectId"
                        filterable
                        :placeholder="
                        jiraTicketDetails.project_key ? jiraTicketDetails.project_key : 'Select or add Jira project'
                      "
                    >
                      <div v-if="jiraSettings.length === 0">
                        <el-option></el-option>
                        <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }"
                                     v-if="$allow('users', 'write')">
                          <a style="margin-left:21px;">+ Add new Jira project</a>
                        </router-link>
                      </div>
                      <div v-else>
                        <el-option
                            v-for="item in jiraSettings"
                            :key="item.id"
                            :label="item.project_id"
                            :value="item.project_id"
                        ></el-option>
                        <div style="margin-top:5px; margin-bottom:5px;" v-if="$allow('users', 'write')">
                          <el-divider direction="horizontal"></el-divider>
                        </div>
                        <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }"
                                     v-if="$allow('users', 'write')">
                          <a style="margin-left:21px;">+ Add new Jira project</a>
                        </router-link>
                      </div>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div class="jira-issue-alignment">
                <span class="jira-issue-selection">Issue</span>
                <el-radio v-model="radio" label="1"><span style="width: 44px;">Task</span></el-radio>
                <el-radio v-model="radio" label="2"><span style="width: 44px;">Story</span></el-radio>
                <el-radio v-model="radio" label="3"><span style="width: 44px;">Bug</span></el-radio>
              </div>

              <div class="pointer-message-jira">
                * If you don’t see Assignee in Jira, your people <br/>
                list is not in sync. You’ll need to Assign the <br/>
                issue again inside Jira.
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div class="jira-button-alignment">
        <span slot="footer" class="dialog-footer">
          <el-button class="btn-cancel" @click="openAssignToDialogVisible = false">
            <span class="styl-cancel">Cancel</span>
          </el-button>
          <el-button class="btn-confirm" type="primary" @click="assignTrailWork(trailIocDetails, queryTrailId)">
            <span class="styl-confirm">Confirm</span>
          </el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog style="text-align:center;" :visible.sync="openSuccessDialogue">
      <div>
        <div class="success-header">
          Success!
        </div>
        <div>
          <div class="jira-success-img-alignment">
            <img src="/static/images/jira-success-logo.svg" alt="logo"/>
          </div>
          <div v-if="checkForSuccessBox" style="height:200px; overflow-y:scroll">
            <p>Following threat Progressions may now be tracked in Jira.</p>
            <div>
              <li v-for="rec of mitigatedProgressionObject" :key="rec.trailID">
                Trail ID:
                <router-link :to="{ name: 'attack-track-details', params: { trailId: rec.trailID } }"
                >{{ rec.trailLabels }}
                </router-link>
                , Ticket link:
                <span v-if="rec.ticketLink !== 'N/A'"><a :href="rec.ticketLink" target="_blank">click here</a></span
                ><span v-else>N/A</span>
              </li>
            </div>
          </div>
          <div v-else>
            <p v-if="disableCheckboxOnPopUp">Jira ticket for {{ selectedAttackTrail.trailIdLabel }} has been
              updated.</p>
            <p v-else>Threat Progression {{ selectedAttackTrail.trailIdLabel }} may now be tracked in Jira.</p>
            <p>
              Your Jira ticket number is: <span style="font-weight:600">{{ jiraTicketDetails.ticket_key }} </span>
            </p>
          </div>
        </div>
        <div class="goto-jira-btn" v-if="!checkForSuccessBox">
          <div>
            <a class="style-goto-jira" :href="jiraTicketDetails.jira_ticket_link" target="_blank"
            ><span>Go to Jira</span>
            </a>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="Mark as Mitigated" :visible.sync="openMitigateDialogVisible">
      <div class="body1 el-form-item">
        <p>
          Are you sure you want to mark this progression as mitigated? Upon confirming, all the pending actions will be
          marked as dismissed.
        </p>
        <el-checkbox
            type="checkbox"
            rows="5"
            v-model="mitigateSimilarProgressions"
            v-if="trailIocDetails.similarTrails && trailIocDetails.similarTrails.length > 1"
        >Mitigate {{ trailIocDetails.similarTrailsCount }} other similar progression(s).
        </el-checkbox
        >
        <div v-if="trailIocDetails.similarTrails && trailIocDetails.similarTrails.length > 1">
          <h6><br/>Similar progressions:</h6>
          <span v-for="(trailId, idx) in trailIocDetails.similarTrails" :key="idx" v-show="trailId !== queryTrailId">
            {{ getSimilarTrailLabel(trailId) }}
            <el-divider v-if="idx !== trailIocDetails.similarTrails.length - 1" direction="vertical"></el-divider>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openMitigateDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="markTrailMitigated(queryTrailId)">Mark as Mitigated</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import {mapGetters} from 'vuex'
import {destroyInverval, registerInverval} from '@/utilities/global.interval'
import {getParsedJSON} from '@/utilities/json.helper'
import {getUserFriendlyTrailLabel} from '@/utilities/trail.helper'
import {allSettled} from '@/utilities/promise.helper'
import {
  MITIGATE_FINGERPRINT_REQUEST,
  TRAIL_ASSIGN_REQ,
  TRAIL_DETAILS_REQ,
  TRAIL_DETAILS_REQ_SUCCESS,
  TRAIL_MITIGATION_REQ,
  TRAIL_WORK_HISTORY_REQ,
  TRAILSINFO_LIST_REQUEST
} from '@/store/modules/trails/trailsinfo.type'
import {USER_LIST_REQUEST, USER_LIST_SUCCESS} from '@/store/modules/user/user.type'
import {ALLOWLIST_DETECTION_SET, RULES_LIST_REQ} from '@/store/modules/rules/rules.type'
import {MITRE_TACTIC_LIST_REQ, MITRE_TECHNIQUE_LIST_REQ} from '@/store/modules/mitre-attack/mitre-attack.type'
import {AGENT_LIST_REQ, CONTAINER_LIST_REQ} from '@/store/modules/agents/agents.type'
import {DETAILS_POLLING_INTERVAL} from '@/constants/polling-interval.constants'
import VClamp from 'vue-clamp'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import DonutChartJs from '@/components/chart/DonutChartJs.vue'
import DonutholeChartLabelPlugin from '@/components/chart/plugins/donuthole-chart-label.plugin'
import ActivitiesTimelineFeed from '@/components/feed/ActivitiesTimelineFeed.vue'
import IocEventDetails from '@/components/feed/ioc-details/IocEventDetails.vue'
import IocMultiEventDetails from '@/components/feed/ioc-details/IocMultiEventDetails.vue'
import IocTrailTableElement from '@/components/table/IOCTrailTableElement.vue'
import LateralMovementEventDetails from '@/components/feed/ioc-details/LateralMovementEventDetails.vue'
import RemediationRecFeed from '@/components/feed/RemediationRecFeed.vue'
import InfluencerList from '@/components/list/InfluencerList.vue'
import UserButton from '@/components/button/UserButton.vue'
import SeverityTag from '@/components/button/SeverityTag.vue'
import ProcessLineageGraph from '@/components/graph/ProcessLineageGraph.vue'
import BlockingResponseFeed from '@/components/feed/BlockingResponseFeed'
import {
  JIRA_ALL_TICKETS,
  JIRA_CREATE_TICKET,
  JIRA_FETCH_TICKETS,
  JIRA_SETTING_REQUEST,
  JIRA_TICKET_FETCH_DETAILS,
  JIRA_TICKET_STATUS_CHANGE
} from '@/store/modules/jira/jira-setting.type'
import ThreatSummary from "./ThreatSummary.vue";
import HostDetailsFeed from "../../../components/feed/HostDetailsFeed.vue";
import {isEmpty} from "lodash";
import HostDetails from "../../hosts/HostDetails.vue";
import HostDetailsCard from "../../hosts/HostDetailsCard.vue";
import EditCriticalityDialog from "../../hosts/EditCriticalityDialog.vue";

export default {
  name: 'CyberAttackTrailDetails',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data() {
    return {
      breadcrumbs: [
        {title: 'Threats'},
        {title: 'Progressions', to: '/monitor/cyber-attacks/active'},
        {title: ''}
      ],
      queryTrailId: this.$route.params.trailId,
      queryTrailLabel: '',
      activeTab: 'threat-summary',
      prevRoute: {},
      selectedIoC: {},
      attackIntervalId: {},
      trailIocDetails: {},
      trailScorePoints: {},
      trailIocDetailsStatus: '',
      trailStateModified: false,
      trailStateBeingModified: false,
      hideActivitiesFeed: true,
      toggleWorkHistory: false,
      toggleHostData: false,
      workHistoryLoading: true,
      workHistoryDetails: [],
      hideIoCDetails: true,
      toggleIoCDetails: false,
      toggleProcessLineageDetails: false,
      toggleRemediation: false,
      showBlockingResponseFeed: false,
      openAssignToDialogVisible: false,
      openMitigateDialogVisible: false,
      mitigateSimilarProgressions: false,
      iocDetails: {
        iocSummary: {},
        iocEventsList: {},
        agentDetails: {}
      },
      responseProgressStarted: false,
      responseProgressTotal: 0,
      responseProgressCompleted: 0,
      responseProgressTitle: '0/0',
      responseProgress: {
        centerDonutTitle: ['', ''],
        datasets: [
          {
            data: [0, 0, 0, 0, 0, 0],
            backgroundColor: [
              'rgba(0, 0, 0, 0.05)',
              'rgba(197, 203, 211, 1.0)',
              'rgba(0, 208, 146, 1.0)',
              'rgba(255, 162, 0, 1.0)',
              'rgba(0, 160, 255, 1.0)',
              'rgba(255, 52, 106, 1.0)'
            ]
          }
        ],
        labels: ['AWAITING ACTION', 'DISMISSED', 'MARKED DONE', 'IN PROGRESS', 'EXECUTED', 'FAILED']
      },
      allowlistDialogVisible: false,
      allowlistItem: {},
      allowlistTypeOptions: [
        {title: 'Program', value: 'program'},
        {title: 'Network', value: 'network'},
        {title: 'File', value: 'file'}
      ],
      checked: false,
      radio: '',
      selectedTrailDetailsForJira: {},
      jiraTicketStatusValues: [
        {
          label: 'Mitigation Not Started',
          value: 'mitigation-not-started'
        },
        {
          label: 'Mitigation in Progress',
          value: 'mitigation-in-progress'
        },
        {
          label: 'Mitigated',
          value: 'mitigated'
        }
      ],
      dialogueBoxTitle: '',
      selectedAttackTrail: {},
      openSuccessDialogue: false, // for success screen after ticket creation.
      selectedAssignee: {},
      checkForSuccessBox: false,
      mitigatedProgressionObject: [],
      disableCheckboxOnPopUp: false,
      iocColorFlag: false,
      expandDescription: {
        expanded: false,
        overflow: null
      },
      agentSelected: {},
      hideHostDataFeed: true,
      openCriticalityDialog: false
    }
  },
  filters: {
    removeInfluencer: function (value) {
      if (!value) return ''
      return value.split('[')[0]
    }
  },
  methods: {
    async onCriticalityChange() {
      this.openCriticalityDialog = false
      await allSettled([
        // this.$store.dispatch(TRAILSINFO_LIST_REQUEST),
        this.$store.dispatch(AGENT_LIST_REQ),
        // this.$store.dispatch(CONTAINER_LIST_REQ)
      ])
      this.fetchAttackTrail()
    },
    isEmpty,
    isElemOverflow(id) {
      try {
        let elmTarget = this.ruleDetailsElm
        // vue-clamp places full text in aria-label
        // overflow occurs if span.innerText < span.ariaLabel
        if (elmTarget) {
          this.expandDescription.overflow = elmTarget.getElementsByTagName('span')[1].ariaLabel.length > elmTarget.getElementsByTagName('span')[1].innerText.length
        }
      } catch (error) {
        console.log("Error accessing table element");
      }
    },
    async fetchRules() {
      if (this.mitreTacticListReqStatus !== 'saved') {
        await allSettled([this.$store.dispatch(MITRE_TACTIC_LIST_REQ), this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ)])
        await this.$store.dispatch(RULES_LIST_REQ)
        return true
      } else {
        return true
      }
    },
    async fetchTrailPrerequisite() {
      await this.fetchRules()

      // Need host/agent info for ioc table host columns
      if (_.isUndefined(this.agentList.models) || !this.agentList.models.length || _.isEmpty(this.containerListInfo)) {
        if (this.trailsinfoReqStatus === '') {
          // Need trails info to link influenced by/influences trail list
          await allSettled([
            this.$store.dispatch(TRAILSINFO_LIST_REQUEST),
            this.$store.dispatch(AGENT_LIST_REQ),
            this.$store.dispatch(CONTAINER_LIST_REQ)
          ])
          this.fetchAttackTrail()
        } else {
          await allSettled([this.$store.dispatch(AGENT_LIST_REQ), this.$store.dispatch(CONTAINER_LIST_REQ)])
          this.fetchAttackTrail()
        }
      } else {
        this.fetchAttackTrail()
      }
      return true
    },
    openAllowlistDialogue(allowlistType) {
      this.$store.dispatch(
          ALLOWLIST_DETECTION_SET,
          _.assignIn({trailIdLabel: this.trailDetails.trailIdLabel}, this.iocDetails)
      )
      this.$router.push({name: 'detection-allowlist'})
    },
    getSimilarTrailLabel(val) {
      let trail = _.find(this.activeTrailsinfoRecords.models, {trailIdHash: val})
      if (trail) {
        return trail.trailIdLabel
      }
      return getUserFriendlyTrailLabel(val)
    },
    getUserFriendlyTrailLabel(val) {
      return getUserFriendlyTrailLabel(val)
    },
    updateTableInterval() {
      this.generateResponseProgress()
      this.attackIntervalId = setTimeout(() => {
        this.updateTable()
      }, DETAILS_POLLING_INTERVAL)
      registerInverval(this.attackIntervalId)
    },
    gotoTrailGraph() {
      if (!this.insightsEnabled) {
        return false
      }
      let trailDetails = this.trailIocDetails
      let system = this.iocDetails.agentDetails.system
      this.$router.push({
        name: 'attack-track-graph',
        params: {platform: system.os, trailId: trailDetails.id}
      })
    },
    gotoThreatHunting() {
      if (!this.insightsEnabled) {
        return false
      }
      let startTimeHrBefore = moment(this.iocDetails.seenTime).subtract({hours: 1})
      let startTimeHrAfter = moment(this.iocDetails.seenTime).add({hours: 1})

      let threatHuntParam = `start_time:${startTimeHrBefore.toISOString()}+end_time:${startTimeHrAfter.toISOString()}+edgeName:in:exec:file:network:system:user+trailId:eq:${
          this.iocDetails.trailId
      }+agentId:eq:${this.iocDetails.agentId}`
      this.$router.push({
        name: 'threat-hunting',
        query: {search: threatHuntParam}
      })
    },
    getInfluencer: function (value) {
      if (!value) return ''
      let influncerArr = getParsedJSON(value)
      // UI-191: return longest running influencee trail (highest dwell time)
      if (influncerArr.length === 1) {
        return influncerArr[0]
      }
      // return longest dwell time influencee trail
      // influencedBy is pre-sorted
      let returnInfluncerArrIndex
      influncerArr.forEach(influencerTrail => {
        let findIndex = _.findIndex(this.trailIocDetails.influencedBy, {
          id: influencerTrail
        })
        if (!returnInfluncerArrIndex) {
          returnInfluncerArrIndex = findIndex
          return
        }
        if (findIndex < returnInfluncerArrIndex) {
          returnInfluncerArrIndex = findIndex
        }
      })
      return this.trailIocDetails.influencedBy[returnInfluncerArrIndex].id
    },
    setBlockingResponseFeedFilter(value) {
      this.$refs.blockingResponseFeed.$data.filterStatusSelection = value
      this.showBlockingResponseFeed = true
    },
    toggleRecommendationSelection(recommendation) {
      let iochashProperty = 'iocHash'
      let iocList = this.trailIocDetails.trailIocList
      // // check if collapsed or not -> collapsedTrailIocList
      if (this.trailIocDetails.collapsedView) {
        iocList = this.trailIocDetails.collapsedTrailIocList
        iochashProperty = 'iocHashList'
      }
      let trailIocIndex = _.findIndex(iocList, ioc => {
        return !ioc.lateralmove && ioc[iochashProperty].includes(recommendation.iocHash)
      })
      if (trailIocIndex > -1) {
        this.$refs.trailTable.selectRowByIndex(trailIocIndex)
      }
    },
    handleSelectionChange(sel) {
      if (sel) {
        sel.agentDetails = this.agentMap.get(sel.agentId) || {}
        sel.containerDetails = {}

        if (sel.containerId && this.containerMap.has(sel.containerId)) {
          sel.containerDetails = this.containerMap.get(sel.containerId);
        }

        this.iocDetails = sel
        this.hideIoCDetails = !this.hideIoCDetails

        this.toggleWorkHistory = true;
        this.toggleRemediation = true;
      } else {
        this.selectSummaryInfo()
      }
    },
    handleHostChange(sel) {
      if (sel) {
        this.agentSelected = sel
        this.hideHostDataFeed = !this.hideHostDataFeed
        this.toggleHostData = true
      }
    },
    selectSummaryInfo() {
      this.selectedIoC = this.trailIocDetails.trailSummary.attackChain
    },
    fetchAttackTrail(trailId) {
      this.trailIocDetailsStatus = 'loading'
      this.$store.dispatch(TRAIL_DETAILS_REQ, this.queryTrailId).then(
          details => {
            this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
              selectedTrail: details.trailIdHash
            })
            this.trailIocDetails = details
            this.trailIocDetails.trailIocInfoList.every((ioc) => {
              ioc.cloudNative === true ? this.iocColorFlag = true : this.iocColorFlag = false
            })
            this.trailIocDetailsStatus = 'saved'
            this.queryTrailLabel = details.trailIdLabel

            // update breadcrumbs
            this.breadcrumbs[2]['title'] = details.trailIdLabel
            if (details.privilege || details.riskScore === 0) {
              this.breadcrumbs[0]['title'] = 'Privileged Activities'
              this.breadcrumbs[1]['title'] = 'Trails'
            }

            // final updates
            this.trailScorePoints = details.trailSummary.scoreContributionHistory
            this.$store.dispatch(TRAIL_DETAILS_REQ_SUCCESS, this.trailIocDetails)
            if (_.isEmpty(this.attackIntervalId)) {
              this.updateTableInterval()
            }

            // generate reponse progress
            this.generateResponseProgress()
          },
          errMsg => {
            this.trailIocDetailsStatus = 'error'
            const h = this.$createElement
            this.$msgbox({
              title: 'Progression Error',
              message: h('p', null, 'There was an error loading the progression you requested.'),
              showCancelButton: false,
              confirmButtonText: 'Ok',
              beforeClose: (action, instance, done) => {
                window.location.href = '/#/dashboard/trails'
              }
            })
          }
      )
    },
    showTrailWorkHistory(trailId) {
      this.hideActivitiesFeed = !this.hideActivitiesFeed
      if (!this.toggleIoCDetails) {
        this.toggleIoCDetails = !this.toggleIoCDetails
      }
      if (!this.toggleRemediation) {
        this.toggleRemediation = !this.toggleRemediation
      }
      this.$store.dispatch(TRAIL_WORK_HISTORY_REQ, trailId).then(
          history => {
            this.workHistoryLoading = false
            this.workHistoryDetails = history
          },
          errMsg => {
            this.workHistoryDetails = []
          }
      )
    },
    markTrailMitigated(trailId) {
      this.trailStateBeingModified = true
      this.trailStateModified = true
      let similarTrailsLabel = []
      for (const similarTrail of this.trailIocDetails.similarTrails) {
        let trailLabel = this.getSimilarTrailLabel(similarTrail)
        similarTrailsLabel.push(trailLabel)
      }
      if (this.mitigateSimilarProgressions) {
        this.$store
            .dispatch(MITIGATE_FINGERPRINT_REQUEST, {
              assignFrom: this.userProfile.email,
              assignTo: this.userProfile.email,
              trails: this.trailIocDetails.similarTrails,
              fingerprintId: this.trailIocDetails.fingerprint
            })
            .then(
                () => {
                  this.trailStateBeingModified = false
                  this.openMitigateDialogVisible = false
                  this.$store.dispatch(JIRA_FETCH_TICKETS).then(_ => {
                    for (let val of this.trailIocDetails.similarTrails) {
                      if (this.fetchTickets.includes(val)) {
                        let payload = {
                          trail_id: val,
                          status_type: 'Mitigated',
                          comment_for_ticket: 'Trail has been mitigated'
                        }
                        this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload)
                      }
                    }

                    this.$store.dispatch(JIRA_ALL_TICKETS).then(() => {
                      this.mitigatedProgressionObject = []
                      let temp = []
                      for (let id of this.trailIocDetails.similarTrails) {
                        if (this.fetchTickets.includes(id)) {
                          for (let ticket of this.jiraAllTickets) {
                            if (ticket.trail_id === id) {
                              temp.push(ticket.jira_ticket_link)
                              break
                            }
                          }
                        } else {
                          temp.push('N/A') // Storing N/A inside array if ticket being not created
                        }
                      }
                      for (let cnt = 0; cnt < this.trailIocDetails.similarTrails.length; cnt++) {
                        let obj = {
                          trailID: this.trailIocDetails.similarTrails[cnt],
                          ticketLink: temp[cnt],
                          trailLabels: similarTrailsLabel[cnt]
                        }
                        this.mitigatedProgressionObject.push(obj)
                      }
                      this.checkForSuccessBox = true // For checking whether a single progression or list of progression selected
                      this.openSuccessDialogue = true
                    })
                  })
                },
                errMsg => {
                  this.trailStateModified = false
                  this.trailStateBeingModified = false
                }
            )
      } else {
        this.$store
            .dispatch(TRAIL_MITIGATION_REQ, {
              assignFrom: this.userProfile.email,
              assignTo: this.userProfile.email,
              trailId: trailId
            })
            .then(
                () => {
                  this.trailStateBeingModified = false
                  this.openMitigateDialogVisible = false
                  let payload = {
                    trail_id: trailId,
                    status_type: 'Mitigated',
                    comment_for_ticket: 'Trail has been mitigated'
                  }
                  this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload).then(_ => {
                    this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                      selectedTrail: trailId
                    })
                    this.openSuccessDialogue = true
                  })
                },
                errMsg => {
                  this.trailStateModified = false
                  this.trailStateBeingModified = false
                }
            )
      }
    },
    handoffTrail(trail) {
      this.checked = false // This is for IntegrateWithJira checkbox handling.
      this.selectedAssignee = _.cloneDeep(trail.ownerId)
      this.selectedAttackTrail = trail
      this.$store
          .dispatch(JIRA_TICKET_FETCH_DETAILS, {
            selectedTrail: this.selectedAttackTrail.trailIdHash
          })
          .then(res => {
            if (this.jiraTicketDetails.issue_type === 'Task') {
              this.radio = '1'
              this.checked = true
              this.disableCheckboxOnPopUp = true
            } else if (this.jiraTicketDetails.issue_type === 'Story') {
              this.radio = '2'
              this.checked = true
              this.disableCheckboxOnPopUp = true
            } else if (this.jiraTicketDetails.issue_type === 'Bug') {
              this.radio = '3'
              this.checked = true
              this.disableCheckboxOnPopUp = true
            } else {
              this.radio = ''
              this.checked = false
              this.disableCheckboxOnPopUp = false
            }

            // This section is responsible for Jira Ticket Status and Confluera progression's sync.
            if (this.jiraTicketDetails !== "None") {
              this.jiraTicketDetails.status = this.mitigationProgressState
              this.selectedTrailDetailsForJira = this.jiraTicketDetails
            }
          })
      this.dialogueBoxTitle = `Threat Progression ${this.selectedAttackTrail.trailIdLabel}`
      this.openAssignToDialogVisible = true
    },
    assignTrailWork(selectedTrail, trailId) {
      // Added selectedTrail.ownerId.email for syncing Assignee.
      selectedTrail.comments = this.selectedTrailDetailsForJira.comments
      if (selectedTrail.assignTo || selectedTrail.ownerId.email) {
        this.$store
            .dispatch(TRAIL_ASSIGN_REQ, {
              assignFrom: this.userProfile.email,
              assignTo: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email,
              trailId: trailId,
              comments: selectedTrail.comments
            })
            .then(
                () => {
                  let assignedToUser = _.find(this.usersList.models, {
                    email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
                  })
                  this.selectedAttackTrail.setOwnerId(assignedToUser)
                  this.openAssignToDialogVisible = false

                  if (this.checked) {
                    // This section is responsible for Jira Ticket Status and Confluera progression's sync.
                    if (
                        this.selectedTrailDetailsForJira.status === 'mitigation-not-started' ||
                        typeof this.selectedTrailDetailsForJira.status === 'undefined'
                    ) {
                      this.selectedTrailDetailsForJira.status = 'To Do'
                    } else if (this.selectedTrailDetailsForJira.status === 'mitigated') {
                      this.selectedTrailDetailsForJira.status = 'Done'
                    } else {
                      this.selectedTrailDetailsForJira.status = 'In Progress'
                    }
                    let payload = {
                      action_name: 'Progression_Assignment',
                      trail_id: selectedTrail.trailIdHash,
                      trail_id_label: selectedTrail.trailIdLabel,
                      target_user: assignedToUser.fullname,
                      project_id: this.selectedTrailDetailsForJira.projectId
                          ? this.selectedTrailDetailsForJira.projectId
                          : this.jiraTicketDetails.project_key,
                      status: this.selectedTrailDetailsForJira.status
                          ? this.selectedTrailDetailsForJira.status
                          : this.jiraTicketDetails.status,
                      type_of_ticket: this.radio,
                      description: selectedTrail.comments
                          ? selectedTrail.comments
                          : this.jiraTicketDetails.ticket_description
                              ? this.jiraTicketDetails.ticket_description
                              : selectedTrail.trailIdLabel,
                      assignee_email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
                    }
                    if (typeof this.jiraTicketDetails !== 'undefined') {
                      if (payload.status === 'Done') {
                        const comment = payload.description
                        // payload.description = 'Some Random text'
                        this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                          let payloadForComment = {
                            trail_id: selectedTrail.trailIdHash,
                            status_type: 'In Progress',
                            comment_for_ticket: comment
                          }
                          this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                            this.openMitigateDialogVisible = true
                            this.selectedTrailDetailsForJira.status = ''
                          })
                        })
                      } else {
                        this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                          const comment = payload.description
                          // payload.description = 'Some Random text'
                          const payloadForComment = {
                            trail_id: selectedTrail.trailIdHash,
                            status_type: payload.status,
                            comment_for_ticket: comment
                          }
                          if (typeof selectedTrail.comments === 'undefined') {
                            this.selectedTrailDetailsForJira.status = ''
                            this.$store
                                .dispatch(JIRA_TICKET_FETCH_DETAILS, {
                                  selectedTrail: this.selectedAttackTrail.trailIdHash
                                })
                                .then(_ => {
                                  this.openSuccessDialogue = true
                                })
                          } else {
                            this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                              this.selectedTrailDetailsForJira.status = ''
                              this.$store
                                  .dispatch(JIRA_TICKET_FETCH_DETAILS, {
                                    selectedTrail: this.selectedAttackTrail.trailIdHash
                                  })
                                  .then(_ => {
                                    this.openSuccessDialogue = true
                                  })
                            })
                          }
                        })
                        this.selectedTrailDetailsForJira.status = ''
                      }
                    } else {
                      if (payload.status === 'Done') {
                        this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                          this.openMitigateDialogVisible = true
                          this.selectedTrailDetailsForJira.status = ''
                        })
                      } else {
                        this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                          this.$store
                              .dispatch(JIRA_TICKET_FETCH_DETAILS, {
                                selectedTrail: this.selectedAttackTrail.trailIdHash
                              })
                              .then(_ => {
                                this.openSuccessDialogue = true
                              })
                        })
                        this.selectedTrailDetailsForJira.status = ''
                      }
                    }
                  } else {
                    if (this.selectedTrailDetailsForJira.status === 'Done') {
                      this.openMitigateDialogVisible = true
                    }
                  }
                  this.$message({
                    type: 'success',
                    message: `Threat Progression ${
                        _.has(selectedTrail, 'trailIdLabel') && selectedTrail.trailIdLabel
                            ? selectedTrail.trailIdLabel
                            : selectedTrail.trailIdHash
                    }
                  is now assigned to ${selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email}.`
                  })
                },
                errMsg => {
                  // keep open & show error
                  this.$message({
                    type: 'error',
                    message: errMsg.data.message || `Something went wrong.`
                  })
                  this.openAssignToDialogVisible = true
                }
            )
      } else {
        this.$message({
          type: 'error',
          message: `Something went wrong. (select assignee and status)`
        })
      }
    },
    updateTable() {
      this.$store.dispatch(TRAIL_DETAILS_REQ, this.queryTrailId).then(details => {
        this.selectSummaryInfo()
        this.$refs.trailTable && this.$refs.trailTable.doRefreshData()
        this.updateTableInterval()
      })
    },
    generateResponseProgress() {
      let started = false
      let total = 0
      let counts = [0, 0, 0, 0, 0, 0]
      this.trailIocDetails.recommendations.forEach(host => {
        host.recommendations.forEach((recommendation, idx) => {
          if (!recommendation.isStatus('invalid')) {
            if (recommendation.isStatus('default')) {
              counts[0]++
              total++
            }
            if (recommendation.isStatus('dismissed')) {
              counts[1]++
              total++
              started = true
            }
            if (recommendation.isStatus('done')) {
              counts[2]++
              total++
              started = true
            }
            if (recommendation.isStatus('pending')) {
              counts[3]++
              total++
            }
            if (recommendation.isStatus('executed')) {
              if (!recommendation.isStatus('reversed')) {
                counts[4]++
              }
              total++
              started = true
            }
            if (recommendation.isStatus('failed')) {
              counts[5]++
              total++
            }
          }
        })
      })
      this.responseProgressStarted = started
      this.responseProgressCompleted = counts[1] + counts[2] + counts[4]
      this.responseProgressTotal = total
      this.responseProgressTitle = this.responseProgressCompleted + '/' + this.responseProgressTotal
      this.responseProgress.centerDonutTitle = [this.responseProgressTitle, 'mitigated']
      this.responseProgress = {
        centerDonutTitle: [this.responseProgressTitle, 'mitigated'],
        datasets: [
          {
            data: counts,
            backgroundColor: [
              'rgba(0, 0, 0, 0.05)',
              'rgba(197, 203, 211, 1.0)',
              'rgba(0, 208, 146, 1.0)',
              'rgba(255, 162, 0, 1.0)',
              'rgba(0, 160, 255, 1.0)',
              'rgba(255, 52, 106, 1.0)'
            ]
          }
        ],
        labels: ['AWAITING ACTION', 'DISMISSED', 'MARKED DONE', 'IN PROGRESS', 'EXECUTED', 'FAILED']
      }

      // re-render donut chart
      this.$refs.responseProgressDonutChart.renderDonutChart(true)

      // prompt user to mark as mitigated
      // not a privilege trail and all recommendations have been completed
      if (
          !this.trailIocDetails.privilege &&
          this.responseProgressTotal > 0 &&
          this.responseProgressCompleted === this.responseProgressTotal
      ) {
        if (!this.trailStateModified && !this.trailStateBeingModified && this.trailIocDetails.state === 'ACTIVE') {
          this.mitigateSimilarProgressions = false
          this.openMitigateDialogVisible = true
          this.trailStateBeingModified = true
        }
      }
    },
    generateCommandChartOptions() {
      return {
        width: 200,
        height: 200,
        rotation: 0.8 * Math.PI,
        circumference: 1.4 * Math.PI,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 30
          }
        },
        tooltips: {
          enabled: true,
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, object) {
              return object.labels[tooltipItem.index] || ''
            }
          }
        }
      }
    },
    gotoTrails() {
      this.$router.push({name: 'active-cyber-attacks'})
      this.openSuccessDialogue = false
    },
    handleThreatHandoffAssigneeChange() {
      const selectedUser = this.usersList.models.filter(user => user.email === this.selectedAttackTrail.assignTo)
      this.selectedAssignee = _.cloneDeep(selectedUser[0])
    },
    handleOpenCriticalityDialog() {
      this.hideHostDataFeed = true
      this.toggleHostData = false
      this.openCriticalityDialog = true
    }
  },
  created() {
    this.fetchTrailPrerequisite()
    if (!this.usersList) {
      this.$store.dispatch(USER_LIST_REQUEST).then(() => {
        this.$store.dispatch(USER_LIST_SUCCESS)
      })
    }
    this.$store.dispatch(JIRA_SETTING_REQUEST)
    this.$store.dispatch(JIRA_FETCH_TICKETS)
  },
  mounted() {
    if (!this.$parent.$parent.collapseNav) {
      this.$parent.$parent.collapseNav = true
    }
  },
  computed: {
    ...mapGetters([
      'agentList',
      'usersList',
      'userProfile',
      'rulesList',
      'trailDetails',
      'trailWorkHistory',
      'privilegedRulesList',
      'trailResponseActionStatus',
      'trailsAssignmentStatus',
      'trailMitigationStatus',
      'usersListStatus',
      'agentListReqStatus',
      'trailsinfoReqStatus',
      'activeTrailsinfoRecords',
      'rulesListReqStatus',
      'mitreTacticListReqStatus',
      'insightsEnabled',
      'containerListInfo',
      'userPref',
      'projectIds',
      'jiraSettings',
      'jiraTicketDetails',
      'fetchTickets',
      'jiraAllTickets'
    ]),
    agentMap() {
      return new Map(this.agentList.models.map(agent => [agent.agentId, agent]))
    },
    containerMap() {
      return new Map(this.containerListInfo.models.map(container => [container.containerId, container]));
    },
    ruleDetailsElm() {
      return document.getElementById('ruledetails-description')
    },
    activeUsersList() {
      return this.usersList.models.filter(model => {
        return model.active
      })
    },
    donutholeChartLabelPlugin() {
      return DonutholeChartLabelPlugin
    },
    mitigationProgressState: {
      get() {
        if (
            ['Done', 'mitigated'].includes(this.jiraTicketDetails.status) ||
            this.trailStateModified ||
            this.trailIocDetails.state === 'MITIGATED'
        ) {
          return 'mitigated'
        } else if (
            ['In Progress', 'mitigation-in-progress'].includes(this.jiraTicketDetails.status) ||
            this.responseProgressStarted
        ) {
          return 'mitigation-in-progress'
        } else if (
            ['To Do', 'mitigation-not-started'].includes(this.jiraTicketDetails.status) ||
            !this.responseProgressStarted
        ) {
          return 'mitigation-not-started'
        } else {
          return 'reopened'
        }
      },
      set(value) {
        if (value === 'mitigated') {
          this.mitigateSimilarProgressions = false
          this.openMitigateDialogVisible = true
        }
      }
    },
    mitigationProgressOptions() {
      return [
        {label: 'Mitigation Not Started', value: 'mitigation-not-started', disabled: true},
        {label: 'Mitigation in Progress', value: 'mitigation-in-progress', disabled: true},
        {
          label: 'Mitigated',
          value: 'mitigated',
          disabled: this.trailStateModified || this.trailIocDetails.state === 'MITIGATED'
        },
        {label: 'Reopened', value: 'reopened', disabled: true}
      ]
    }
  },
  watch: {
    prevRoute(newVal, oldVal) {
      if (!_.isEmpty(newVal) && newVal.path !== '/') {
        this.breadcrumbs[1].to = {name: newVal.name, params: newVal.params, query: newVal.query}
      }
    },
    trailResponseActionStatus(newVal, oldVal) {
      if (newVal === 'completed') {
        this.fetchAttackTrail()
      }
    },
    hideIoCDetails(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.toggleWorkHistory = !this.toggleWorkHistory
        this.toggleRemediation = !this.toggleRemediation
        this.toggleProcessLineageDetails = false
        if (newVal === true) {
          this.$refs.trailTable.clearRowSelection()
        }
      } else if (newVal !== oldVal) {
        // when toggling aside details bar, set rules description overflow
        this.expandDescription.expanded = false // reset to false on sidebar toggle
        setTimeout(() => {
          this.isElemOverflow('ruledetails-description')
        })
      }
    },
    hideHostDataFeed(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.toggleHostData = !this.toggleHostData
      }
    },
    hideActivitiesFeed(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.toggleIoCDetails = !this.toggleIoCDetails
        this.toggleRemediation = !this.toggleRemediation
      }
    },
    '$route.params.trailId': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          destroyInverval(this.attackIntervalId)

          // manual location bar entry
          if (this.$route.fullPath.includes('#')) {
            let urlPath = this.$route.fullPath.split('/')
            urlPath[urlPath.length - 1] = urlPath[urlPath.length - 1].replace(/#/g, '%23')
            urlPath = urlPath.join('/')
            this.$router.replace(urlPath)
          } else {
            this.queryTrailId = newVal
            this.hideIoCDetails = true
            this.toggleWorkHistory = false
            this.$refs.iocDetailsAside.close()
            this.fetchAttackTrail()
          }
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    // use empty function to kill interval update calls (timing insurance)
    this.updateTableInterval = (function () {
    })()
    destroyInverval(this.attackIntervalId)
  },
  components: {
    EditCriticalityDialog,
    HostDetailsCard,
    HostDetails,
    HostDetailsFeed,
    PageHeaders,
    UserButton,
    DonutChartJs,
    AsideSidebar,
    IocTrailTableElement,
    ActivitiesTimelineFeed,
    IocEventDetails,
    RemediationRecFeed,
    InfluencerList,
    IocMultiEventDetails,
    ProcessLineageGraph,
    LateralMovementEventDetails,
    BlockingResponseFeed,
    VClamp,
    ThreatSummary,
    SeverityTag
  }
}
</script>

<style scoped>
@import 'assets/styles/global_classes.css';
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/colors.css';

.layout-container .container .view {
  padding: 0;
}

.page-headers {
  padding: 10px 20px;
  border-bottom: solid 1px var(--border-color);

  .el-divider {
    height: 2em;
  }

  .mitigate-trail {
    position: relative;

    .icon-user-edit {
      position: absolute;
      right: -2px;
      top: 16px;

      >>> .material-icons {
        position: relative;
        font-size: 12px;
        border-radius: 50%;
        border: 1px solid var(--aluminum-400);
        background-color: var(--aluminum-200);
      }
    }
  }
}

.el-tabs {
  height: 100%;

  >>> .el-tabs__header {
    margin: 0;
  }

  >>> .el-tabs__nav-wrap {
    padding: 5px 20px 0 20px;
  }

  >>> .el-tabs__item {
    height: 45px;
    font-size: 12px;
    text-transform: uppercase;

    .status {
      padding: 0 0 0 20px;
      color: #333333;
      font-size: 18px;

      .icon {
        width: 14px;
        height: 14px;
        background: #f1004e;
        margin: -1px;
      }
    }
  }

  >>> .el-tabs__content {
    height: calc(100% - 55px);
  }

  >>> .el-tab-pane {
    height: calc(100%);
  }

  >>> .el-tabs__nav-wrap::after {
    background-color: var(--border-color);
    height: 1px;
  }
}

.icon {
  display: inline-block;
  height: 16px;
  width: 16px;
  mask-size: 100% auto;
  mask-repeat: no-repeat;
  mask-position: center;
}

.main-content {
  position: relative;
  height: calc(100% - 78px);

  .el-row,
  .el-col {
    height: 100%;
  }
}

.killchain-info {
  padding: 20px;

  .command-chart {
    position: relative;
    width: 200px;
    height: 200px;
  }

  .statistics {
    margin: 0 0 15px 0;
  }

  .title {
    height: 40px;
    padding: 0 37px 0 10px;
    color: #444444;
    font-size: 12px;
    line-height: 40px;
    text-transform: uppercase;
    border-top: solid 2px #e2e6e9;

    .count {
      font-size: 13px;
    }
  }
}

.trail-details {
  height: 100%;
  border-left: solid 1px var(--border-color);
}

>>> .table-menu-options {
  padding: 0 20px 0 0;
}

.aside-sidebar {
  height: 100%;
}

.aside-details {
  flex-grow: 1;
}

.heading {
  .fal {
    background: #e07373;
    border-radius: 50%;
  }

  .box {
    min-width: 25px;

    .score {
      color: var(--gray-600);
    }
  }

  .box.score {
    min-width: 50px;
  }
}

.dialog-box-footer {
  position: absolute;
  border-top: 1px solid var(--border-color);
  bottom: 0px;
  padding: 20px;
  width: 100%;
  text-align: center;
  background: white;
}

.c-icon-history {
  height: 21px;
  width: 25px;
  margin: auto;
  background: var(--aluminum-500);
  mask: url('/static/images/history.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
}

.c-icon-mitigate {
  height: 22px;
  width: 18px;
  margin: auto;
  background: var(--aluminum-500);
  mask: url('/static/images/mitigate.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
}

.status-tag {
  width: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-active {
  color: #315D1C;
  border: 0.5px solid #AEDB97;
  background: #F0F9EB;
}

.status-inactive {
  color: #292c32;
  border-color: var(--aluminum-900);
  background: #292c32;
}

.status-mitigated {
  border: 0.5px solid #9AC9FA;
  color: #003A80;
  background: #ECF5FF;
}

.status-reopened {
  border: 0.5px solid #EDCB98;
  color: #654B23;
  background: #FDF6EC;
}

.status-awaiting {
  background-color: rgba(0, 0, 0, 0.08);
}

.status-dismissed {
  background-color: rgba(197, 203, 211, 1);
}

.status-done {
  background-color: rgba(0, 208, 146, 1);
}

.status-pending {
  background-color: rgba(255, 162, 0, 1);
}

.status-executed {
  background-color: rgba(0, 160, 255, 1);
}

.status-failed {
  background-color: rgba(255, 52, 106, 1);
}

.aside-ioc-title {
  position: relative;

  .open-process-lineage {
    position: absolute;
    bottom: 0px;
    line-height: 30px;

    .material-icons {
      vertical-align: middle;

      &:first-of-type {
        font-size: 1.2em;
      }

      &:last-of-type {
        font-size: 1.8em;
      }
    }
  }
}

.process-lineage-details {
  >>> .aside-sidebar {
    width: 50% !important;
  }
}

.local-trailid {
  .material-icons {
    font-size: 14px;
    vertical-align: middle;
  }
}

.box-for-Create-Allowlist {
  min-width: 25px;
  margin: 21px 0 15px 40px;
}

.el-form-item ::before,
.el-form-item ::after {
  color: #454b60;
}

.el-form-item {
  color: #454b60;
}

.el-select {
  height: 41px;
  width: 279px;
  border-radius: 2px;
  border: 1px solid #a1a8ae;
  background-color: #ffffff;
}

.el-radio {
  color: #454b60;
}

.the-title-of-threat-copy {
  height: 48px;
  width: 298px;
  color: #454b60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 12px;
  margin-left: 115px;
}

.pointer-message-jira {
  height: 72px;
  width: 316px;
  color: #454b60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 26px;
  margin-left: 115px;
}

.container {
  display: flex;
  flex-direction: row;
}

.left-section {
  height: 400px;
  display: block;
  width: 48%;
}

.right-section {
  height: 370px;
  display: block;
  width: 50%;
}

.btn-confirm {
  height: 36px;
  width: 132px;
  border-radius: 4px;
  background-color: #1890fa;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.btn-cancel {
  box-sizing: border-box;
  height: 36px;
  width: 132px;
  border: 1px solid #a1a8ae;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.styl-cancel {
  height: 20px;
  width: 68px;
  color: #454b60;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

.styl-confirm {
  height: 20px;
  width: 68px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

>>> .el-form-item__label {
  color: #454b60;
  font-weight: 500;
}

>>> .el-textarea__inner {
  width: 279px;
  margin-left: 98px;
  margin-top: -15px;
  border: 1px solid #a1a8ae;
}

>>> .el-dialog__title {
  height: 35px;
  width: 428px;
  color: #454b60;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 35px;
}

>>> .el-dialog__body {
  padding-left: 63px;
  padding-right: 73px;
}

>>> .el-dialog__header {
  padding: 36px 28px 10px;
  margin-left: 30px;
}

>>> .el-dialog {
  border-radius: 7px;
  width: 965px;
  height: 591px;
}

>>> .el-radio {
  width: 49px;
}

>>> .el-input--suffix .el-input__inner {
  border: none;
}

.threat-assignee_dropdown {
  >>> .el-input--prefix .el-input__prefix {
    left: 13px;
  }

  >>> .el-input--suffix .el-input__inner {
    border: none;
    padding-left: 58px;
  }
}

>>> .avatar-circle,
.avatar-circle:hover {
  background: #77dab4 !important;
}

.jira-text-integrate-with-jira {
  height: 24px;
  width: 137px;
  color: #454b60;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 20px;
}

.jira-issue-selection {
  margin-right: 36px;
  color: #454b60;
  font-weight: 500;
}

.jira-button-alignment {
  margin-top: -28px;
  float: right;
}

.jira-project-alignment {
  margin-top: 30px;
  margin-left: 56px;
}

.jira-issue-alignment {
  margin-left: 115px;
  margin-top: 25px;
}

.jira-project-selection {
  width: 400px;
  margin-left: -15px;
}

>>> .el-input__inner::-webkit-input-placeholder,
>>> .el-input__inner {
  color: #454b60;
}

>>> .el-input__inner::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #454b60;
  opacity: 1; /* Firefox */
}

>>> .el-textarea__inner::-webkit-input-placeholder,
>>> .el-textarea__inner {
  color: #454b60;
  /* border:1px solid #A1A8AE; */
}

>>> .el-input__inner:-ms-input-placeholder,
>>> .el-input__inner::-ms-input-placeholder {
  color: #454b60;
}

.success-header {
  font-size: 30px;
  color: #297fca;
  font-weight: 300;
  margin-top: -15px;
  margin-bottom: 65px;
}

.goto-jira-btn {
  height: 36px;
  width: 139px;
  border-radius: 4px;
  background-color: #1a90fa;
  /* align-items: center; */
  margin-left: 42%;
  margin-top: 45px;
}

.style-goto-jira {
  height: 30px;
  width: 139px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  position: absolute;
  margin-top: 7px;
  margin-left: -69px;
  text-decoration: none;
}

.jira-success-img-alignment {
  margin-top: 37px;
  margin-bottom: 28px;
}

.back-to-threat {
  margin-top: 20px;
  font-weight: 600;
}

>>> .el-divider--horizontal {
  margin-top: 5px;
  margin-bottom: 5px;
}

.add-new-jira-project {
  height: 30px;
  width: 215px;
  color: #454b60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 30px;
  margin-left: 21px;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.agent-title-wrapper {
  display: flex;
  flex-direction: column;

  .value {
    margin-top: 25px;
    margin-bottom: 15px;
    align-self: flex-end;
    color: #0066E3;
  }

  .agent-title {
    display: flex;
    align-items: center;
    font-size: 23px;

    .host-name {
      width: 100%;
    }

    .agent-icon {
      background-size: 20px;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/CyberAttackTrailDetails.vue